var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-none"},[_c('qr-code-make',{ref:"qrCanvas",attrs:{"file":_vm.qrSvgDataUrl,"link":_vm.fullLink},on:{"update:file":function($event){_vm.qrSvgDataUrl=$event},"save":function($event){_vm.qrDesign = $event}},model:{value:(_vm.qrDesign),callback:function ($$v) {_vm.qrDesign=$$v},expression:"qrDesign"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }